var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFB40F",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "m6.28 11.72 8.372-8.372c.336-.336.895.01.745.46l-2.068 6.205a.75.75 0 0 0 .711.987h3.15a.75.75 0 0 1 .53 1.28l-8.372 8.372c-.336.336-.895-.01-.745-.46l2.068-6.205A.75.75 0 0 0 9.959 13H6.811a.75.75 0 0 1-.53-1.28Z"
})));
export default SvgBolt;